var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"app"}},[_c('AppHeader'),_c('main',{staticClass:"w-100"},[_c('router-view')],1),_c('AppFooter',{class:{ 'd-block': _vm.shouldShow(), 'd-none': _vm.shouldHide() }})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }